import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems: { label: string; to: string; anchor?: string }[] = [
  { label: "首页", to: "/" },
  { label: "热瓜榜", to: "/", anchor: "rank" },
  { label: "全部瓜料", to: "/category" },
  { label: "娱乐爆料", to: "/category/yule" },
  { label: "影视综艺", to: "/category/yingshi" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.hash]);

  const handleAnchor = (anchor?: string) => {
    if (!anchor) return;
    window.setTimeout(() => {
      const el = document.getElementById(anchor);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 80);
  };

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="hidden md:block bg-foreground-950 text-background-100">
        <div className="w-full px-4 md:px-8 h-9 flex items-center justify-between text-xs">
          <p className="flex items-center gap-2">
            <i className="ri-fire-fill text-accent-400" aria-hidden="true"></i>
            全网热点吃瓜视觉合集 · 视频 / 图片 / 截图 / 实拍持续更新
          </p>
          <p className="text-background-300">今日热瓜 40+ 条 · 更新于 2026-09-10</p>
        </div>
      </div>

      <div
        className={`w-full transition-all duration-300 ${
          scrolled
            ? "bg-background-50/95 backdrop-blur border-b border-background-200"
            : "bg-background-50 border-b border-transparent"
        }`}
      >
        <div className="w-full px-4 md:px-8 h-16 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 shrink-0 group">
            <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-xl transition-transform group-hover:scale-105">
              <i className="ri-fire-line" aria-hidden="true"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-bold text-lg text-foreground-950 tracking-wide">
                瓜田前线
              </span>
              <span className="text-[10px] tracking-[0.18em] text-foreground-500 font-label mt-0.5">
                GUATIAN FRONTLINE
              </span>
            </span>
          </Link>

          <nav aria-label="主导航" className="hidden lg:flex items-center gap-1">
            {navItems.map((item) =>
              item.anchor ? (
                <Link
                  key={item.label}
                  to={item.to}
                  onClick={() => handleAnchor(item.anchor)}
                  className="px-3.5 py-2 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <NavLink
                  key={item.label}
                  to={item.to}
                  end={item.to === "/"}
                  className={({ isActive }) =>
                    `px-3.5 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                      isActive
                        ? "text-primary-700 bg-primary-50"
                        : "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              )
            )}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#subscribe"
              className="hidden sm:inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-notification-3-line" aria-hidden="true"></i>
              订阅更新
            </a>
            <button
              type="button"
              aria-label={open ? "关闭菜单" : "打开菜单"}
              aria-expanded={open}
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden border-t border-background-200 bg-background-50">
            <nav aria-label="移动端导航" className="px-4 py-3 flex flex-col">
              {navItems.map((item) => (
                <Link
                  key={item.label}
                  to={item.to}
                  onClick={() => handleAnchor(item.anchor)}
                  className="px-3 py-3 rounded-md text-sm font-medium text-foreground-800 hover:bg-primary-50 hover:text-primary-700 transition-colors"
                >
                  {item.label}
                </Link>
              ))}
              <a
                href="#subscribe"
                className="mt-2 px-3 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium text-center"
              >
                订阅更新提醒
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}